import {
  ALL_HEADER_COLOR_OPTIONS,
  ALL_ZEBRA_COLOR_OPTIONS,
  resolveHeaderTokenOverrides,
  resolveZebraTokenOverrides
} from './colorOptions'

export const TABLE_PARAMETERS = [
  {
    key: 'headerColor',
    type: 'color',
    label: 'Header Color',
    default: 'neutral',
    options: ALL_HEADER_COLOR_OPTIONS,
    customFields: [
      { key: 'headerColorBg', label: 'Background', default: '#514E91' },
      { key: 'headerColorText', label: 'Text Color', default: '#FFFFFF' }
    ]
  },
  {
    key: 'hideHeader',
    type: 'boolean',
    label: 'Hide Header',
    default: false
  },
  {
    key: 'zebraStripe',
    type: 'color',
    label: 'Zebra Striping',
    default: 'none',
    options: ALL_ZEBRA_COLOR_OPTIONS,
    customFields: [
      { key: 'zebraStripeBg', label: 'Stripe Color', default: '#F0F0F0' }
    ]
  },
  {
    key: 'separatedRows',
    type: 'boolean',
    label: 'Row Dividers',
    default: false
  },
  {
    key: 'tableBorder',
    type: 'boolean',
    label: 'Outer Border',
    default: false
  }
]

const SEMANTIC_HEADER_CLASSES = new Set(['primary', 'secondary', 'accent'])

export function resolveTableParams (params, extra = {}) {
  const tableClasses = []
  const styles = {}

  // Header color
  if (SEMANTIC_HEADER_CLASSES.has(params.headerColor)) {
    tableClasses.push(params.headerColor)
  } else {
    const overrides = resolveHeaderTokenOverrides(params.headerColor, params)
    if (overrides) Object.assign(styles, overrides)
  }

  // Zebra striping
  if (params.zebraStripe && params.zebraStripe !== 'none') {
    if (SEMANTIC_HEADER_CLASSES.has(params.zebraStripe)) {
      tableClasses.push(`zebra-rows-${params.zebraStripe}`)
    } else if (params.zebraStripe === 'neutral') {
      tableClasses.push('zebra-rows')
    } else {
      tableClasses.push('zebra-rows')
      const overrides = resolveZebraTokenOverrides(params.zebraStripe, params)
      if (overrides) Object.assign(styles, overrides)
    }
  }

  if (params.separatedRows) tableClasses.push('separated-rows')
  if (params.tableBorder) tableClasses.push('table-border')

  return {
    props: { includeHeader: !params.hideHeader },
    className: extra.className ?? null,
    tableClassName: tableClasses.join(' ') || null,
    styles: { ...styles, ...(extra.styles ?? {}) }
  }
}
